module.exports = __webpack_public_path__ + "static/media/2.573a67b4.jpg";